/**
 * Scope kinds — "which account ids does a request cover?". Three real kinds plus
 * deferred `admin`; see `docs3/scopes-and-cache.md` §1.
 *
 * - `account`  — single current account (account layout)
 * - `group`    — member accounts universe (group layout, non-ticket pages)
 * - `tickets`  — member ∪ ticketGroup accounts universe (group layout, ticket pages)
 * - `admin`    — superAdmin all-data scope (deferred)
 *
 * Org-group and ticket-group pickers are NOT kinds — they only narrow `active`
 * within the current universe (the ticket-group selection also picks a settings
 * host, tracked in route/query state, not on the scope).
 */
export const SCOPES = Object.freeze({
  ACCOUNT: 'account',
  GROUP: 'group',
  TICKETS: 'tickets',
  ADMIN: 'admin',
})

/**
 * Default shape for `scopeUtility.resolve.host()` — non-merged (no settings host).
 * Spread and override for resolved TicketAccount / TicketGroup hosts.
 */
export const HOST = Object.freeze({
  merged: false,
  onModel: null,
  hostId: null,
  scopeKey: null,
  apiScope: null,
  ticketGroupId: null,
})
